import { apiSlice } from "./apiSlice";

export const financialBGSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Get all BankGuarantee List
        getBankGuaranteeList: builder.query({
            query: (params) => ({
                url: `BankGuaranteeTracker`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllBankGuarantee"],
        }),

        // Export all data (without pagination) in Excel File
        getExportBankGuaranteeList: builder.query({
            query: (params) => ({
                url: `BankGuaranteeTracker`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        // Create new BankGuarantee
        createBankGuarantee: builder.mutation({
            query: (body) => ({
                url: `BankGuaranteeTracker`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllBankGuarantee"],
        }),

        // Update BankGuarantee
        updateBankGuarantee: builder.mutation({
            query: (body) => ({
                url: `BankGuaranteeTracker`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ['AllBankGuarantee']
        }),

    })
})

export const { useLazyGetBankGuaranteeListQuery, useCreateBankGuaranteeMutation, useUpdateBankGuaranteeMutation, useLazyGetExportBankGuaranteeListQuery } = financialBGSlice;